import { EditableField, LabelMenu, LabelMenuOption } from '@chikara/ui';
import { Card as CardType } from '@/features/card/types/card.types';
import { isBasic } from '@/shared/config/permissions';
import { useAuth } from '@/features/auth/hooks/useAuth';
import styles from '@/features/card/pages/CardDetailPage/CardDetailPage.module.css';
import { t } from '@/i18n';
import { formatCardAliasForDisplay, formatCardLabelForDisplay } from '@/features/card/utils/cardDisplayLabels';

interface CardDetailMetadataProps {
    card: CardType;
    onEditAlias: () => void;
    tags: LabelMenuOption[];
    selectedTag?: string;
    onTagChange: (value: string) => void;
    onEditTags?: () => void;
    onCreateTag?: () => void;
    isTagMenuOpen: boolean;
    setIsTagMenuOpen: (isOpen: boolean) => void;
    handleEditLabel: () => void;
    tagButtonRef: React.RefObject<HTMLDivElement | null>;
    createDisabled?: boolean;
    createTooltip?: string;
}

export const CardDetailMetadata = ({
    card,
    onEditAlias,
    tags,
    selectedTag,
    onTagChange,
    onEditTags,
    onCreateTag,
    isTagMenuOpen,
    handleEditLabel,
    setIsTagMenuOpen,
    tagButtonRef,
    createDisabled,
    createTooltip,
}: CardDetailMetadataProps) => {
    const { userData } = useAuth();
    const basic = isBasic(userData.role);

    return (
        <div className={styles.metadataContainer}>
            <div className={styles.metadataGrid}>
                <EditableField
                    label={t('dashboard.card.detail.info.alias')}
                    value={formatCardAliasForDisplay(card.cardAlias)}
                    onEdit={!basic ? onEditAlias : undefined}
                    className={styles.metadataField}
                />
                <div className={styles.separator} />

                <div ref={tagButtonRef} className={styles.metadataFieldWrapper}>
                    <EditableField
                        label={t('dashboard.card.detail.info.label')}
                        value={formatCardLabelForDisplay(card.label)}
                        onEdit={!basic ? handleEditLabel : undefined}
                        className={styles.metadataField}
                    />
                    <LabelMenu
                        isOpen={isTagMenuOpen}
                        onClose={() => setIsTagMenuOpen(false)}
                        triggerRef={tagButtonRef}
                        options={tags}
                        value={selectedTag}
                        onChange={onTagChange}
                        onEdit={onEditTags}
                        onCreate={() => { setIsTagMenuOpen(false); onCreateTag?.(); }}
                        title={t('dashboard.card.detail.info.label')}
                        createDisabled={createDisabled}
                        createTooltip={createTooltip}
                    />
                </div>
            </div>
        </div>
    );
};
